export type TextAlignment = 'left' | 'center' | 'right';
export type TextFontStyle = 'normal' | 'italic';
export type TextFontWeight = 200 | 400 | 500 | 600 | 700;
export type TextFontFamily =
  | 'Inter'
  | 'Arial'
  | 'Times New Roman'
  | 'Georgia'
  | 'Verdana'
  | 'Courier New'
  | 'Comic Sans MS';

export const DEFAULT_TEXT_FONT_FAMILY = 'Inter' as const;

export interface SelectOption<T> {
  label: string;
  value: T;
}

export interface IconToggleOption<T> {
  value: T;
  icon: string;
  label: string;
}

export const TEXT_ALIGNMENT_OPTIONS: IconToggleOption<TextAlignment>[] = [
  {
    value: 'left',
    icon: 'assets/icons/format-align-left.svg',
    label: 'Align left',
  },
  {
    value: 'center',
    icon: 'assets/icons/format-align-center.svg',
    label: 'Align center',
  },
  {
    value: 'right',
    icon: 'assets/icons/format-align-right.svg',
    label: 'Align right',
  },
];

export const TEXT_FONT_STYLE_OPTIONS: IconToggleOption<TextFontStyle>[] = [
  {
    value: 'normal',
    icon: 'assets/icons/format-color-text.svg',
    label: 'Normal',
  },
  {
    value: 'italic',
    icon: 'assets/icons/format-italic.svg',
    label: 'Italic',
  },
];

export const TEXT_FONT_WEIGHT_OPTIONS: SelectOption<TextFontWeight>[] = [
  { label: 'Light', value: 200 },
  { label: 'Regular', value: 400 },
  { label: 'Medium', value: 500 },
  { label: 'Semibold', value: 600 },
  { label: 'Bold', value: 700 },
];

export const TEXT_FONT_FAMILY_OPTIONS: SelectOption<TextFontFamily>[] = [
  { label: 'Inter', value: 'Inter' },
  { label: 'Arial', value: 'Arial' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Verdana', value: 'Verdana' },
  { label: 'Courier New', value: 'Courier New' },
  { label: 'Comic Sans MS', value: 'Comic Sans MS' },
];
